<template>
  <transition name="slide-down">
    <div
        class="store-warning-container"
    >
      <div class="store-warning-content">
        <div class="store-warning-icon">
          <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="warning-icon"
          >
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
            <line x1="12" y1="9" x2="12" y2="13"></line>
            <line x1="12" y1="17" x2="12.01" y2="17"></line>
          </svg>
        </div>
        <div class="store-warning-text">
          <p v-html="message"></p>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'Notification',
  props: {
    show: { type: Boolean, required: true },
    message: { type: String, required: true },
    typeClass: { type: String, default: 'alert-success' },
    isHtml: { type: Boolean, default: false },
  },
}
</script>
<style scoped>
.store-warning-container {
  @media only screen and (min-width: 1280px) {
    position: fixed;
  }
  top: 0;
  left: 0;
  width: 100%;
  background-color: #FFE5E5; /* More reddish background */
  z-index: 9999;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
.store-warning-content {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 15px 16px;
}
.store-warning-icon {
  margin-right: 16px;
  color: #DC3545; /* Bootstrap danger red */
}
.warning-icon {
  stroke: #DC3545; /* Match icon color to warning color */
}
.store-warning-text {
padding: 0 20px;
  color: #721c24; /* Dark red text for contrast */
  font-size: 14px;
}
/* Transition animations */
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease;
}
.slide-down-enter,
.slide-down-leave-to {
  opacity: 0;
  transform: translateY(-100%);
}
</style>
